import ApiService from '@/services/api';

const API = new ApiService();

export const state = {
    roleItem: {},
    rolesList: [],
    rolesTotal: 0,
    modules: [],
    error: null
}

export const mutations = {
    UPDATE_ROLE(state, list){
        state.roleItem = list;
    },
    UPDATE_ROLES_LIST(state, list){
        state.rolesList = list;
    },
    UPDATE_ROLES_TOTAL(state, total){
        state.rolesTotal = total;
    },
    UPDATE_MODULES(state, modules){
      state.modules = modules;
  },
    SET_ERROR(state, error){
        state.error = error
    },
}

export const actions = {
    async getRolesList({ commit }) {
        return new Promise((resolve, reject) => {
          API.post('/role/list-roles')
            .then(res => {
              commit('UPDATE_ROLES_LIST', res.message.rows.Items);
              commit('UPDATE_ROLES_TOTAL', res.message.rows.TotalCount);
              resolve(res)
            })
            .catch(err => reject(err));
        });
    },

    async getRole({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/role/get-role', params)
            .then(res => {
              commit('UPDATE_ROLE', res.message.rows.Item);
              resolve(res)
            })
            .catch(err => reject(err));
        });
    },

    async createRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/role/create-role', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async updateRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/role/update-role', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async deleteRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
          API.post('/role/delete-role', params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
                commit('SET_ERROR', err)
                reject(err)
            });
        });
    },

    async getModules({ commit }) {
      return new Promise((resolve, reject) => {
        API.post('/role/get-modules')
          .then(res => {
            commit('UPDATE_MODULES', res.message);
            resolve(res)
          })
          .catch(err => reject(err));
      });
  },
}